import apiClient from "../../utils/clients/axios";

// report issue data final submit
export const createTaskSheetsIssueData = async (payload) => {
  const response = await apiClient.post(
    `/api/quality_control/report_issue`,
    payload
  );
  return response;
};

// active employees synced from the ERP, for the employee name autocomplete
export const getActiveEmployees = async () => {
  const response = await apiClient.get(`/api/quality_control/employees`);
  return response?.data || [];
};

// open machines synced from the ERP, for the machine name autocomplete
export const getOpenMachines = async () => {
  const response = await apiClient.get(`/api/quality_control/machines`);
  return response?.data || [];
};

// reasons for the report form's Reason dropdown
export const getIssueReasons = async () => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/reasons`
  );
  return response?.data || [];
};

// whether the logged-in user may add reasons (configured logins only)
export const getReasonPermissions = async () => {
  const response = await apiClient.get(
    `/api/quality_control/report_issue/reasons/permissions`
  );
  return Boolean(response?.data?.canAdd);
};

// add a reason from the form; returns the existing one if the name matches
export const createIssueReason = async (name) => {
  const response = await apiClient.post(
    `/api/quality_control/report_issue/reasons`,
    { name }
  );
  return response?.data;
};

// update report issue data both for employee and manager
export const updateTaskSheetsIssueData = async (params) => {
  const { payload, id } = params;

  const response = await apiClient.put(
    `/api/quality_control/report_issue/${id}`,
    payload
  );
  return response;
};
